<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <Markers stage1></Markers>
            <CustomActivatorSelect
                class=""
                :items="filteredConnectorsList"
                :transition="false"
                item-value="type"
                v-model="selectedConnectorType"
                :multiple="false"
            >
                <template v-slot:activator="{ selected, _id }">
                    <TextField
                        label="Источник"
                        hide-details
                        persistent-label
                        class="select-input bot-select"
                        append-icon="mdi-menu-down"
                        :id="_id"
                        :value="selected ? selected.name : ''"
                        readonly
                    >
                    </TextField>
                </template>
            </CustomActivatorSelect>

            <div class="d-flex justify-end">
                <v-btn @click="next" color="mainNew" class="mt-2 white--text" :disabled="!selectedConnector"
                >Далее</v-btn
                >
            </div>
        </div>
    </div>
</template>

<script>
import intersection from 'lodash/intersection'

import Markers from '@/components/addConnector/Markers.vue'
import Breadcrumbs from '@/components/Breadcrumbs'
import { mapState } from 'vuex'
import CustomActivatorSelect from '../components/inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../components/inputs/BaseInputOutlined.vue'
import TextField from '../components/inputs/TextField.vue'
import { CONNECTOR_TYPES, TELEPHONY_CONNECTOR_TYPES, GCB_EXTERNAL_CONNECTOR_TYPES } from '@/vars/general'
import { useBillingStore } from '@/store/stores/billing'
export default {
    name: 'AddConnectorStage1',
    components: { Markers, Breadcrumbs, CustomActivatorSelect, BaseInputOutlined, TextField },

    data: () => ({
        selectedConnectorType: null,
        telephonysTypeListForTariff1:[
            CONNECTOR_TYPES.telephonyMegaphone,
            CONNECTOR_TYPES.telephonyMango,
            CONNECTOR_TYPES.telephonyBeeline,
            CONNECTOR_TYPES.telephonyProstyiZvonki,
            CONNECTOR_TYPES.sipuni,
            CONNECTOR_TYPES.pbxOnline,
            CONNECTOR_TYPES.whatsapp,
            CONNECTOR_TYPES.amoCrm
        ],
        telephonysTypeListForTariff3:[
            CONNECTOR_TYPES.amoCrm
        ],
        billingStore : useBillingStore(),
        hiddenConnectors:[
            CONNECTOR_TYPES.profSalonBatV2,
            CONNECTOR_TYPES.sonline,
            CONNECTOR_TYPES.moiSklad,
            CONNECTOR_TYPES.helix1C,
            CONNECTOR_TYPES.mango,
            CONNECTOR_TYPES.chat2desk,
            CONNECTOR_TYPES.arnica,
            CONNECTOR_TYPES.telegramHr, // Создается только разработчиками
            CONNECTOR_TYPES.lenaLenina, // Отображается в разделе, но не доступна для подключения
            CONNECTOR_TYPES.profSalon, // Исключен из возможных к добавлению
            CONNECTOR_TYPES.whatsapp, // Легаси «WhatsApp бот от Data Heroes» — скрыт, миграция на dh-whatsapp завершена
        ]
    }),
    computed: {
        ...mapState(['connectorsList']),
        ...mapState('project', ['loggedAddingConnector', 'currentAddingConnector']),
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        breadcrumbs() {
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ДОБАВИТЬ ИСТОЧНИК',
                    disabled: true,
                    to: '',
                },
            ]
        },
        connectorsCount() {
            const connectorsCount = {}
            for (const connector of this.project.connectors) {
                connectorsCount[connector.connectorType] === undefined
                    ? (connectorsCount[connector.connectorType] = 1)
                    : connectorsCount[connector.connectorType]++
            }
            return connectorsCount
        },
        connectorTypesInProject() {
            return this.project.connectors.map(el => el.connectorType)
        },
        filteredConnectorsList() {
            const currentTariff = this.project.billingEnabled && this.billingStore.getCurrentTariff(this.project.id) ? this.billingStore.getCurrentTariff(this.project.id).id : null
            // Получаем тип только из query параметра (при клике на карточку)
            // Не используем currentAddingConnector для фильтрации, чтобы при возврате с Stage2 показывались все коннекторы
            const typeFromQuery = this.$router.currentRoute.query.type
            const connectorType = typeFromQuery
            
            const isTelephonyType = connectorType && TELEPHONY_CONNECTOR_TYPES.includes(connectorType)
            const isSourceType = connectorType && GCB_EXTERNAL_CONNECTOR_TYPES.includes(connectorType)
            const isWhatsappType = connectorType === CONNECTOR_TYPES.whatsapp
            
            return this.connectorsList
                .filter(con => {
                    // Если передан тип whatsapp, показываем только WhatsApp от DH
                    if (isWhatsappType) {
                        return con.type === CONNECTOR_TYPES.whatsapp && (con.showCondition ? con.showCondition(this.project) : true)
                    }
                    // Если передан тип телефонии, показываем только телефонию
                    if (isTelephonyType) {
                        return TELEPHONY_CONNECTOR_TYPES.includes(con.type) && (con.showCondition ? con.showCondition(this.project) : true)
                    }
                    // Если передан тип источника данных, показываем только источники (исключая lenaLenina)
                    if (isSourceType) {
                        return GCB_EXTERNAL_CONNECTOR_TYPES.includes(con.type) && 
                               con.type !== CONNECTOR_TYPES.lenaLenina && 
                               (con.showCondition ? con.showCondition(this.project) : true)
                    }
                    return con.showCondition ? con.showCondition(this.project) : true
                })
                .map(con => {
                    const maxCount = this.connectorsList.find(con2 => con2.type === con.type).maxCount
                    // Если whatsappBasis уже подключен, отключаем его в списке
                    if (con.type === CONNECTOR_TYPES.whatsappBasis && this.connectorsCount[CONNECTOR_TYPES.whatsappBasis] > 0) {
                        return Object.assign({}, con, {
                            disabled: true,
                            name: `${con.name} (уже подключено)`,
                        })
                    }
                    //Находим есть ли конкурирующие коннекторы (например yClients нельяз подключить одновременно с universeSoft)
                    const concurrectedConnectorsTypes = con.notIncludes
                        ? intersection(this.connectorTypesInProject, con.notIncludes)
                        : []
                    const concurrency = concurrectedConnectorsTypes.length > 0
                    //Если maxCount === -1, ограничений по количеству коннеторов нет
                    if (maxCount === -1 && !concurrency) {
                        return con
                    }
                    if (concurrency) {
                        return Object.assign({}, con, {
                            name: `${con.name} (уже подключен ${
                                this.connectorsList.find(el => el.type === concurrectedConnectorsTypes[0])
                                    .name
                            })`,
                            disabled: true,
                        })
                    }
                    if (maxCount > 1) {
                        if (this.connectorsCount[con.type] >= maxCount) {
                            return Object.assign({}, con, {
                                name: `${con.name} (подключено ${
                                    this.connectorsCount[con.type]
                                } из ${maxCount} возможных)`,
                                disabled: this.connectorsCount[con.type] >= maxCount ? true : false,
                            })
                        }
                    }

                    if(currentTariff === 'tariff1' && this.telephonysTypeListForTariff1.includes(con.type)){
                        return Object.assign({}, con, {
                            disabled: true,
                            name: `${con.name} (недоступный тариф)`,
                        })
                    }
                    if(currentTariff === 'tariff3' && this.telephonysTypeListForTariff3.includes(con.type)){
                        return Object.assign({}, con, {
                            disabled: true,
                            name: `${con.name} (недоступный тариф)`,
                        })
                    }
                    else{
                        return con
                    }

                    if (this.connectorsCount[con.type] >= maxCount) {
                        return Object.assign({}, con, {
                            disabled: true,
                            name: `${con.name} (уже подключено)`,
                        })
                    } else {
                        return con
                    }
                }).filter(con => {
                    return !this.hiddenConnectors.includes(con.type)
              })
        },
        selectedConnector() {
            if (!this.selectedConnectorType) return
            return this.filteredConnectorsList.find(el => el.type === this.selectedConnectorType)
        },
    },
    methods: {
        next() {
            this.$store.commit('project/updateCurrentAddingConnector', this.selectedConnector)
            const path = this.$router.currentRoute.path
                .split('/')
                .slice(0, 3)
                .join('/')
            // Сохраняем параметр type в query при переходе на следующий этап
            const typeFromQuery = this.$router.currentRoute.query.type
            const queryParams = typeFromQuery ? { type: typeFromQuery } : {}
            this.$router.push({ path: `${path}/addConnectorStage2`, query: queryParams })
        },
    },
    async created() {
        if (this.$router.currentRoute.query.fromStage == 3) {
            await this.$store.dispatch('project/deleteConnector', this.loggedAddingConnector.connectorId)
        }
    },
    mounted() {
        // Если передан параметр type в query, предустанавливаем выбранный тип
        // Используем только query параметр для предустановки, чтобы при возврате с Stage2 не применялась фильтрация
        const typeFromQuery = this.$router.currentRoute.query.type
        
        if (typeFromQuery && this.filteredConnectorsList.find(con => con.type === typeFromQuery)) {
            this.selectedConnectorType = typeFromQuery
        } else if (this.currentAddingConnector && !typeFromQuery) {
            // Если нет query параметра, но есть currentAddingConnector (возврат с Stage2), предустанавливаем его тип
            const connectorType = this.currentAddingConnector.type || this.currentAddingConnector.connectorType
            if (connectorType && this.filteredConnectorsList.find(con => con.type === connectorType)) {
                this.selectedConnectorType = connectorType
            }
        }
    },
}
</script>
<style lang="sass" scoped></style>
